import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "123"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex justify-space-between align-center mt-4"
}
const _hoisted_3 = { class: "text-body-1 text-no-wrap" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  class: "text-body-1",
  "_v-show": "getEntrySelectedCount(entry.segmentId, entry.price)"
}
const _hoisted_6 = {
  key: 1,
  class: "text-body-1"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { class: "d-flex pa-sm-3 pa-2 flex-wrap justify-sm-space-between align-start" }
const _hoisted_9 = { class: "text-xs-h5 text-sm-h6 text-no-wrap" }
const _hoisted_10 = { class: "text-xs-h5 text-sm-h6 text-no-wrap text-grey pl-4" }
const _hoisted_11 = {
  key: 0,
  class: "text-subtitle-1 py-2"
}
const _hoisted_12 = {
  class: "justify-center pb-0 d-flex flex-column",
  id: "price-legend",
  style: {"position":"absolute","top":"66px","left":"6px","width":"fit-content"}
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "pa-3 d-flex flex-column" }
const _hoisted_15 = { class: "text-body-1" }
const _hoisted_16 = { class: "d-inline-flex align-center" }
const _hoisted_17 = { class: "text-body-1 mx-1" }
const _hoisted_18 = {
  key: 2,
  class: "d-sm-flex"
}
const _hoisted_19 = { class: "v-col-sm-10 d-flex flex-wrap justify-sm-start justify-center pt-3 px-0" }
const _hoisted_20 = { class: "d-inline-flex text-no-wrap justify-space-between v-col ma-0 pa-0" }
const _hoisted_21 = { class: "d-inline-flex text-no-wrap justify-space-between v-col ma-0 pa-0" }
const _hoisted_22 = { class: "v-col-sm-2 pt-2 pb-12 justify-center align-start" }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { key: 2 }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-left ml-2 text-caption" }, [
  /*#__PURE__*/_createTextVNode(" Согласен с "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://letolifefest.ru/upload/oferta-muzfest.pdf",
    class: "text-black"
  }, "Публичной офертой")
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-left ml-2 text-caption" }, [
  /*#__PURE__*/_createTextVNode(" Согласен с "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://letolifefest.ru/upload/agreement-muzfest.pdf",
    class: "text-black"
  }, "Согласие на обработку персональных данных")
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-left ml-2 text-caption" }, [
  /*#__PURE__*/_createTextVNode(" Согласен с "),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://letolifefest.ru/upload/policy-muzfest.pdf",
    class: "text-black"
  }, "Политикой в отношении защиты и обработки персональных данных")
], -1)
const _hoisted_33 = { key: 3 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-left ml-2 text-caption" }, [
  /*#__PURE__*/_createTextVNode(" Согласен с '"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://peachrest.ru/upload/policy.pdf",
    class: "text-black"
  }, "Политика конфиденциальности"),
  /*#__PURE__*/_createTextVNode("'")
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-left ml-2 text-caption" }, [
  /*#__PURE__*/_createTextVNode(" Согласен с '"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://peachrest.ru/upload/agreement.pdf",
    class: "text-black"
  }, "Согласие на обработку Персональных данных"),
  /*#__PURE__*/_createTextVNode("'")
], -1)
const _hoisted_36 = { key: 4 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "checkbox-left ml-2 text-caption" }, [
  /*#__PURE__*/_createTextVNode(" Согласен с '"),
  /*#__PURE__*/_createElementVNode("a", {
    target: "_blank",
    href: "https://peachrest.ru/upload/policy.pdf",
    class: "text-black"
  }, "Документ с сайта origin"),
  /*#__PURE__*/_createTextVNode("'")
], -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = { class: "d-inline-flex" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_42 = { class: "text-subtitle-1 font-weight-bold" }
const _hoisted_43 = { class: "text-body-1" }
const _hoisted_44 = { class: "text-caption" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_46 = {
  key: 0,
  class: "text-subtitle-1"
}
const _hoisted_47 = {
  key: 1,
  class: "text-subtitle-1"
}
const _hoisted_48 = {
  key: 2,
  class: "text-subtitle-1"
}
const _hoisted_49 = {
  key: 3,
  class: "text-subtitle-1"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("img", {
  src: "sbp_logo2.png",
  height: "32",
  alt: "СБП"
}, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = {
  key: 0,
  class: "text-caption text-grey"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_69 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_70 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_71 = {
  key: 0,
  class: "text-subtitle-1 text-red-darken-1"
}
const _hoisted_72 = { class: "text-subtitle-1" }
const _hoisted_73 = { class: "text-subtitle-2" }
const _hoisted_74 = { class: "text-caption" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("h6", null, "Мероприятие не найдено или уже прошло", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_space = _resolveComponent("space")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.eventData)
      ? (_openBlock(), _createBlock(_component_v_dialog, {
          key: 0,
          modelValue: _ctx.dialogEntryTickets,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogEntryTickets) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              "min-width": "400px",
              "max-width": "400px",
              class: "pa-2 align-center align-self-center"
            }, {
              default: _withCtx(() => [
                (_ctx.eventData.entryTickets && _ctx.eventData.entryTickets.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.entryTickets, (entry) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.id
                        }, [
                          (!_ctx.dialogEntryTicketsSegment || (_ctx.dialogEntryTicketsSegment && entry.segmentId.toString() == _ctx.dialogEntryTicketsSegment) )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                  _createTextVNode(_toDisplayString(entry.segmentName) + " ", 1),
                                  _hoisted_4,
                                  _createTextVNode(" " + _toDisplayString(_ctx.formatMoney(entry.price)), 1)
                                ]),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  size: "x-small",
                                  variant: "tonal",
                                  icon: "mdi-minus",
                                  class: "ma-1",
                                  onClick: ($event: any) => (_ctx.delEntryToSelected(entry.id)),
                                  disabled: !_ctx.getEntrySelectedCount(entry.segmentId, entry.price)
                                }, null, 8, ["onClick", "disabled"]),
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.getEntrySelectedCount(entry.segmentId, entry.price)), 1),
                                _createVNode(_component_v_btn, {
                                  size: "x-small",
                                  variant: "tonal",
                                  icon: "mdi-plus",
                                  class: "ma-1",
                                  onClick: ($event: any) => (_ctx.addEntryToSelected(entry))
                                }, null, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, "Нет билетов")),
                _hoisted_7,
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: _ctx.primaryColor,
                      class: "font-weight-bold",
                      variant: "flat",
                      onClick: _cache[0] || (_cache[0] = ()=>{_ctx.dialogEntryTickets=false ;_ctx.dialogEntryTicketsSegment=''})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("OK ")
                      ]),
                      _: 1
                    }, 8, ["color"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.eventData)
      ? (_openBlock(), _createBlock(_component_v_sheet, {
          key: 1,
          class: "mx-md-6 mx-sm-4 mx-xs-0",
          "max-width": "880px",
          _style: "background: #42b983"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window, {
              modelValue: _ctx.step,
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.step) = $event)),
              disabled: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_window_item, {
                  value: 1,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.eventData.name), 1),
                      _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.eventData.date), 1),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeDialog=true)),
                        icon: "mdi-close",
                        variant: "flat",
                        size: "small",
                        class: "ma-0 pa-0",
                        style: {"position":"absolute","right":"4px","top":"4px"}
                      })
                    ]),
                    (!Object.keys(_ctx.eventData.seats??{}).length && (!_ctx.eventData.entryTickets || !_ctx.eventData.entryTickets.length))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, " На данный момент свободных мест нет, попробуйте позже. "))
                      : _createCommentVNode("", true),
                    (_ctx.svgHtml)
                      ? (_openBlock(), _createBlock(_component_v_sheet, {
                          key: 1,
                          class: "",
                          height: "400px"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_sheet, {
                              border: "",
                              innerHTML: _ctx.svgHtml,
                              class: "pa-0",
                              onTouchstart: _ctx.onSvgMapTouchStart,
                              onMousedown: _ctx.onSvgMapMouseDown,
                              onMouseup: _ctx.onSvgMapMouseUp,
                              onTouchend: _ctx.onSvgMapClick,
                              onClick: _ctx.onSvgMapClick,
                              _mouseup: "onSvgMapMouseUp",
                              height: "400px",
                              "max-height": "400px",
                              _style: "height: 500px;"
                            }, null, 8, ["innerHTML", "onTouchstart", "onMousedown", "onMouseup", "onTouchend", "onClick"]),
                            _createElementVNode("div", _hoisted_12, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pricesValues.slice().reverse(), (price, i) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                  size: "small",
                                  key: price,
                                  class: "ma-1",
                                  style: _normalizeStyle({color: 'white', background: ''+_ctx.pricesColors[_ctx.pricesColors.length-i-1], filter: 'brightness(1.1)'})
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formatMoney(price)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["style"]))
                              }), 128))
                            ]),
                            _createVNode(_component_v_btn, {
                              icon: "mdi-plus",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.zoom(true))),
                              class: "mb-1 elevation-2",
                              style: {"position":"relative","top":"-108px","left":"42%"}
                            }),
                            _hoisted_13,
                            _createVNode(_component_v_btn, {
                              icon: "mdi-minus",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.zoom(false))),
                              class: "elevation-2",
                              style: {"position":"relative","top":"-108px","left":"42%"}
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventData.entryTickets, (entry) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.id,
                          class: "d-inline-flex text-no-wrap justify-end align-center"
                        }, [
                          _createElementVNode("div", _hoisted_15, _toDisplayString(entry.segmentName), 1),
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.formatMoney(entry.price)), 1),
                            _createVNode(_component_v_spacer),
                            _withDirectives(_createVNode(_component_v_btn, {
                              size: "small",
                              variant: "tonal",
                              icon: "mdi-minus",
                              class: "ma-1",
                              onClick: ($event: any) => (_ctx.delEntryToSelected(entry.id))
                            }, null, 8, ["onClick"]), [
                              [_vShow, _ctx.getEntrySelectedCount(entry.segmentId, entry.price)]
                            ]),
                            _withDirectives(_createElementVNode("div", { class: "text-body-1" }, _toDisplayString(_ctx.getEntrySelectedCount(entry.segmentId, entry.price)), 513), [
                              [_vShow, _ctx.getEntrySelectedCount(entry.segmentId, entry.price)]
                            ]),
                            _createVNode(_component_v_btn, {
                              size: "small",
                              variant: "tonal",
                              icon: "mdi-plus",
                              class: "ma-1",
                              onClick: ($event: any) => (_ctx.addEntryToSelected(entry))
                            }, null, 8, ["onClick"])
                          ])
                        ]))
                      }), 128))
                    ]),
                    (_ctx.getTotalCount())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            (_ctx.eventData.seats)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selected.seats, (seatId) => {
                                  return (_openBlock(), _createBlock(_component_v_card, {
                                    key: seatId,
                                    width: "138",
                                    "max-width": "138",
                                    "max-height": "110",
                                    class: "bg-grey-lighten-4 mr-2 mb-2",
                                    style: {"cursor":"pointer","user-select":"none"},
                                    onMouseover: ($event: any) => (_ctx.onHoverSelected(seatId)),
                                    onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onLeaveSelected()))
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_component_v_card_subtitle, { class: "text-body-1 pt-3 pb-0 pa-0 v-col-9" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatMoney(_ctx.eventData.seats[seatId].price)), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_btn, {
                                          variant: "plain",
                                          class: "ma-0 pa-0 v-col-3",
                                          _density: "compact",
                                          size: "small",
                                          icon: "mdi-close",
                                          onClick: ($event: any) => (_ctx.removeSeatFromSelected(seatId))
                                        }, null, 8, ["onClick"])
                                      ]),
                                      _createVNode(_component_v_card_text, { class: "text-body-2 ma-0 pa-0 text-no-wrap" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.eventData.seats[seatId].seatLabel), 1)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_card_subtitle, { class: "pa-0 text-no-wrap text-caption upp" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.eventData.seats[seatId].seatDesc), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onMouseover"]))
                                }), 128))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.entry, (entry, index) => {
                              return (_openBlock(), _createBlock(_component_v_card, {
                                key: index,
                                width: "138",
                                "max-width": "138",
                                "max-height": "110",
                                class: "bg-grey-lighten-4 mr-2 mb-2",
                                style: {"cursor":"pointer","user-select":"none"}
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_21, [
                                    _createVNode(_component_v_card_subtitle, { class: "text-body-1 pt-3 pb-0 pa-0 v-col-9" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatMoney(entry.price)), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_btn, {
                                      variant: "plain",
                                      class: "ma-0 pa-0 v-col-3",
                                      _density: "compact",
                                      size: "small",
                                      icon: "mdi-close",
                                      onClick: ($event: any) => (_ctx.delEntryToSelected(entry.id))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _createVNode(_component_v_card_text, { class: "text-body-2 ma-0 pa-0" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(entry.segmentName), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createVNode(_component_v_card_title, { class: "text-xs-h3 text-md-h5 mt-1 pa-0" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.formatMoney(_ctx.getTotalSum())), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              color: _ctx.primaryColor,
                              class: "font-weight-bold ma-3",
                              variant: "flat",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.step=2))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Далее ")
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_v_card, {
                            flat: "",
                            color: "light-blue-lighten-5",
                            "max-width": "300",
                            rounded: "",
                            class: "v-container d-flex justify-center mt-4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "large",
                                icon: "mdi-information-variant-circle",
                                color: "light-blue",
                                class: "pr-3"
                              }),
                              _createVNode(_component_space),
                              _createTextVNode("Билеты без сервисного сбора")
                            ]),
                            _: 1
                          })
                        ])),
                    _hoisted_24,
                    _hoisted_25
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: 2,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_26,
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Оформление заказа")
                      ]),
                      _: 1
                    }),
                    _hoisted_27,
                    _createVNode(_component_v_card_subtitle, { class: "text-wrap" }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Введите данные для получения " + _toDisplayString(_ctx.eventData.ticketNameOf.toLowerCase()), 1)
                      ]),
                      _: 1
                    }),
                    _hoisted_28,
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "v-container justify-center align-center align-self-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, {
                          onSubmit: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"])),
                          ref: "clientForm",
                          class: "pa-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.client.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.client.name) = $event)),
                              rules: _ctx.nameRules,
                              label: "Имя",
                              name: "name",
                              type: "text",
                              variant: "underlined"
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.client.email,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.client.email) = $event)),
                              rules: _ctx.emailRules,
                              label: "E-mail для получения билетов",
                              type: "email",
                              name: "email",
                              variant: "underlined"
                            }, null, 8, ["modelValue", "rules"]),
                            (_ctx.eventData.collectTel)
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 0,
                                  modelValue: _ctx.client.tel,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.client.tel) = $event)),
                                  rules: _ctx.telRules,
                                  prefix: "+7",
                                  label: "Телефон",
                                  type: "tel",
                                  name: "tel",
                                  variant: "underlined"
                                }, null, 8, ["modelValue", "rules"]))
                              : _createCommentVNode("", true),
                            (_ctx.eventData.collectBirthDate)
                              ? (_openBlock(), _createBlock(_component_v_text_field, {
                                  key: 1,
                                  _type: "date",
                                  modelValue: _ctx.client.birthDate,
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.client.birthDate) = $event)),
                                  rules: _ctx.dateRules,
                                  onInput: _ctx.onInputBirthDate,
                                  label: "Дата рождения",
                                  variant: "underlined",
                                  required: ""
                                }, null, 8, ["modelValue", "rules", "onInput"]))
                              : _createCommentVNode("", true),
                            (_ctx.getOriginDomain()==='letolifefest.ru')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.agree1,
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.agree1) = $event)),
                                    hideDetails: "",
                                    rules: _ctx.agreeRules
                                  }, {
                                    label: _withCtx(() => [
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "rules"]),
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.agree2,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.agree2) = $event)),
                                    hideDetails: "",
                                    rules: _ctx.agreeRules
                                  }, {
                                    label: _withCtx(() => [
                                      _hoisted_31
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "rules"]),
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.agree3,
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.agree3) = $event)),
                                    hideDetails: "",
                                    rules: _ctx.agreeRules
                                  }, {
                                    label: _withCtx(() => [
                                      _hoisted_32
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "rules"])
                                ]))
                              : (_ctx.getOriginDomain()==='peachrest.ru')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.agree1,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.agree1) = $event)),
                                      hideDetails: "",
                                      rules: _ctx.agreeRules
                                    }, {
                                      label: _withCtx(() => [
                                        _hoisted_34
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_v_checkbox, {
                                      modelValue: _ctx.agree2,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.agree2) = $event)),
                                      hideDetails: "",
                                      rules: _ctx.agreeRules
                                    }, {
                                      label: _withCtx(() => [
                                        _hoisted_35
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"])
                                  ]))
                                : _createCommentVNode("", true),
                            (_ctx.getOriginDomain()==='undefined')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                  _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.agree1,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.agree1) = $event)),
                                    hideDetails: "",
                                    rules: _ctx.agreeRules
                                  }, {
                                    label: _withCtx(() => [
                                      _hoisted_37
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "rules"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 512),
                        _createVNode(_component_v_container, { class: "d-flex justify-space-between" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              class: "",
                              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.step=1)),
                              variant: "tonal"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Назад ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              color: _ctx.primaryColor,
                              _disabled: "client.error",
                              type: "submit",
                              class: "font-weight-bold",
                              variant: "flat",
                              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onSubmitClientForm()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Далее ")
                              ]),
                              _: 1
                            }, 8, ["color"])
                          ]),
                          _: 1
                        }),
                        _hoisted_38
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: 3,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_v_sheet, {
                        width: "320px",
                        class: "d-flex flex-column align-center"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40,
                          _createVNode(_component_v_card_title, { class: "pt-0 pb-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode("Подтверждение заказа")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { class: "d-flex flex-column align-start pb-0" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.eventData.date), 1),
                              _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.eventData.name), 1),
                              _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.eventData.venueName), 1),
                              _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.eventData.venueAddress), 1),
                              _hoisted_45,
                              (_ctx.client.name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.client.name), 1))
                                : _createCommentVNode("", true),
                              (_ctx.client.birthDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, "Дата рождения: " + _toDisplayString(_ctx.client.birthDate), 1))
                                : _createCommentVNode("", true),
                              (_ctx.client.tel)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.client.tel), 1))
                                : _createCommentVNode("", true),
                              (_ctx.client.email)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_ctx.client.email), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_container, { class: "d-flex flex-column justify-space-between" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_expansion_panels, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, { class: "text-body-1 font-weight-bold" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.segmentsDiscounts ? 'Стоимость со скидкой' : 'Стоимость:') + " " + _toDisplayString(_ctx.formatMoney(_ctx.getTotalSum())) + " ", 1),
                                          _hoisted_50,
                                          _hoisted_51,
                                          _createTextVNode(" " + _toDisplayString(_ctx.eventData.ticketNameOf) + ": " + _toDisplayString(_ctx.getTotalCount()), 1)
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.eventData.seats)
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selected.seats, (seatId) => {
                                            return (_openBlock(), _createBlock(_component_v_expansion_panel_text, {
                                              key: seatId,
                                              class: "text-body-1"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.eventData.seats[seatId.toString()].seatLabel) + " " + _toDisplayString(_ctx.eventData.seats[seatId].seatDesc) + ", " + _toDisplayString(_ctx.formatMoney(Math.round(_ctx.eventData.seats[seatId].price * _ctx.getSegmentDiscountK(_ctx.eventData.seats[seatId].segmentId)))) + " " + _toDisplayString(_ctx.segmentsDiscounts && _ctx.segmentsDiscounts.has(_ctx.eventData.seats[seatId].segmentId) ? 'скидка ' + _ctx.segmentsDiscounts.get(_ctx.eventData.seats[seatId].segmentId)+ '%' : ''), 1)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected.entry, (entry) => {
                                        return (_openBlock(), _createBlock(_component_v_expansion_panel_text, {
                                          key: entry.id,
                                          class: "text-body-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(entry.segmentName) + ", " + _toDisplayString(_ctx.formatMoney(Math.round(entry.price * _ctx.getSegmentDiscountK(entry.segmentId)))) + " " + _toDisplayString(_ctx.segmentsDiscounts && _ctx.segmentsDiscounts.has(entry.segmentId) ? 'скидка ' + _ctx.segmentsDiscounts.get(entry.segmentId) + '%' : ''), 1)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _hoisted_52,
                              (!_ctx.segmentsDiscounts)
                                ? (_openBlock(), _createBlock(_component_v_dialog, {
                                    key: 0,
                                    modelValue: _ctx.dialogPromo,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.dialogPromo) = $event)),
                                    width: "auto"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_btn, _mergeProps(props, {
                                        class: "my-2",
                                        color: _ctx.primaryColor,
                                        variant: "tonal"
                                      }), {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Ввести промокод % ")
                                        ]),
                                        _: 2
                                      }, 1040, ["color"])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        "max-width": "400",
                                        "min-width": "320",
                                        loading: _ctx.dialogPromoPending,
                                        disabled: _ctx.dialogPromoPending
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            focused: "",
                                            clearable: "",
                                            autofocus: "",
                                            modelValue: _ctx.promoCode,
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.promoCode) = $event)),
                                            "error-messages": _ctx.promoCodeError,
                                            label: "Промокод",
                                            variant: "outlined",
                                            class: "pa-4 pb-0 font-weight-bold",
                                            onInput: _cache[21] || (_cache[21] = ($event: any) => (_ctx.promoCode = _ctx.promoCode.toUpperCase())),
                                            color: _ctx.primaryColor
                                          }, null, 8, ["modelValue", "error-messages", "color"]),
                                          _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                onClick: _cache[22] || (_cache[22] = ($event: any) => {_ctx.dialogPromo = false; _ctx.promoCode = ''; _ctx.promoCodeError = ''}),
                                                variant: "tonal"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("Отмена ")
                                                ]),
                                                _: 1
                                              }),
                                              _createVNode(_component_v_spacer),
                                              _createVNode(_component_v_btn, {
                                                color: _ctx.primaryColor,
                                                class: "my-2 font-weight-bold",
                                                onClick: _ctx.applyPromoCode,
                                                variant: "tonal",
                                                disabled: !_ctx.promoCode.trim()
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" Применить ")
                                                ]),
                                                _: 1
                                              }, 8, ["color", "onClick", "disabled"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["loading", "disabled"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                              (_ctx.eventData.payAvailable)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    color: _ctx.primaryColor,
                                    class: "my-2 font-weight-bold",
                                    variant: "flat",
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.createOrder('bankcard')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_ctx.getTotalSum() > 0 ? 'Оплатить картой' : 'Оформить Заказ'), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["color"]))
                                : _createCommentVNode("", true),
                              (_ctx.eventData.sbpAvailable)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 2,
                                    color: "",
                                    class: "my-2 font-weight-bold bg-green-lighten-5",
                                    variant: "flat",
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.createOrder('sbp')))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Оплатить "),
                                      _hoisted_53
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_dialog, {
                                modelValue: _ctx.dialogSellerInfo,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.dialogSellerInfo) = $event)),
                                width: "auto"
                              }, {
                                activator: _withCtx(({ props }) => [
                                  _createVNode(_component_v_card_subtitle, _mergeProps(props, { style: {"cursor":"pointer"} }), {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Информация о продавце ")
                                    ]),
                                    _: 2
                                  }, 1040)
                                ]),
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card, { "max-width": "340" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_text, {
                                        style: {"white-space":"pre"},
                                        class: "text-wrap"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.eventData.legalInfo), 1)
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_card_actions, { class: "justify-center" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            color: _ctx.primaryColor,
                                            onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.dialogSellerInfo = false))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Закрыть")
                                            ]),
                                            _: 1
                                          }, 8, ["color"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _hoisted_54,
                              _createVNode(_component_v_btn, {
                                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.step=2)),
                                class: "my-2",
                                variant: "tonal"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Назад")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, " Вы будете перенаправлены на платёжный шлюз ПАО СБЕРБАНК. "))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: 4,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_56,
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Резервирование...")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "d-inline-flex flex-column justify-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_progress_circular, {
                              class: "mt-12",
                              "model-value": "20",
                              size: "100",
                              color: _ctx.primaryColor,
                              indeterminate: ""
                            }, null, 8, ["color"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: 5,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "d-inline-flex flex-column justify-start"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_57,
                        _hoisted_58,
                        _createVNode(_component_v_btn, {
                          href: _ctx.payUrl,
                          target: "_blank",
                          class: "my-2 font-weight-bold"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Нажмите, если платежная форма"),
                            _hoisted_59,
                            _createTextVNode("не открылась автоматически ")
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: 6,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_60,
                    _hoisted_61,
                    _hoisted_62,
                    _createVNode(_component_v_icon, {
                      class: "mb-5",
                      color: "success",
                      icon: "mdi-check-circle",
                      size: "112"
                    }),
                    _hoisted_63,
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Успешная покупка")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "d-inline-flex flex-column justify-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Ваши билеты отправлены на почту " + _toDisplayString(_ctx.client.email), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, { onClick: _ctx.close }, {
                              default: _withCtx(() => [
                                _createTextVNode(" OK ")
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _hoisted_64,
                            _hoisted_65
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_window_item, {
                  value: 7,
                  disabled: ""
                }, {
                  default: _withCtx(() => [
                    _hoisted_66,
                    _hoisted_67,
                    _hoisted_68,
                    _createVNode(_component_v_icon, {
                      class: "mb-5",
                      color: "amber-lighten-3",
                      icon: "mdi-close-circle-outline",
                      size: "112"
                    }),
                    _hoisted_69,
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode("Что-то пошло не так")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_sheet, {
                      width: "320px",
                      class: "d-inline-flex flex-column justify-start"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_form, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, null, {
                              default: _withCtx(() => [
                                _createTextVNode(" Нам не удалось завершить оплату Вашего заказа. Пожалуйста повторите попытку. ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.windowReload()))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" OK ")
                              ]),
                              _: 1
                            }),
                            _hoisted_70
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (_ctx.seatOver && !_ctx.isMapPanned)
              ? (_openBlock(), _createBlock(_component_v_sheet, {
                  key: 0,
                  rounded: "",
                  border: "",
                  ref: "seatTooltip",
                  class: "elevation-6 pa-2",
                  style: _normalizeStyle([{"position":"absolute"}, _ctx.seatTooltipStyle])
                }, {
                  default: _withCtx(() => [
                    (_ctx.getTotalCount() >= _ctx.getTicketsLimit())
                      ? (_openBlock(), _createElementBlock("div", _hoisted_71, " Не более " + _toDisplayString(_ctx.getTicketsLimit()) + " в один заказ ", 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_72, _toDisplayString(_ctx.formatMoney(_ctx.seatOver.price)), 1),
                    _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.seatOver.seatLabel), 1),
                    _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.seatOver.seatDesc), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : _createCommentVNode("", true),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.closeDialog,
              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.closeDialog) = $event)),
              width: "auto"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { "max-width": "260" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, { class: "ma-3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Отменить покупку?")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.closeDialog=false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Нет")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: _ctx.primaryColor,
                          onClick: _ctx.close
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Да")
                          ]),
                          _: 1
                        }, 8, ["color", "onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : (_ctx.eventData === null)
        ? (_openBlock(), _createBlock(_component_v_sheet, { key: 2 }, {
            default: _withCtx(() => [
              _hoisted_75
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_sheet, {
            key: 3,
            class: "d-flex justify-center align-center",
            height: "500px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                "model-value": "20",
                size: "100",
                color: _ctx.primaryColor,
                indeterminate: ""
              }, null, 8, ["color"])
            ]),
            _: 1
          }))
  ], 64))
}